import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CaretDoublePrevIcon = (props) => (
  <SvgIcon viewBox="0 0 16 15" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.383235 6.88117L6.50678 0.757624C6.84849 0.415916 7.40251 0.415916 7.74422 0.757624C8.08593 1.09933 8.08593 1.65335 7.74422 1.99506L2.23939 7.49989L7.74422 13.0047C8.08593 13.3464 8.08593 13.9004 7.74422 14.2422C7.40251 14.5839 6.84849 14.5839 6.50678 14.2422L0.383235 8.11861C0.0415259 7.7769 0.0415259 7.22288 0.383235 6.88117Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25678 6.88117L14.3803 0.757624C14.722 0.415916 15.2761 0.415916 15.6178 0.757624C15.9595 1.09933 15.9595 1.65335 15.6178 1.99506L10.1129 7.49989L15.6178 13.0047C15.9595 13.3464 15.9595 13.9004 15.6178 14.2422C15.2761 14.5839 14.722 14.5839 14.3803 14.2422L8.25678 8.11861C7.91507 7.7769 7.91507 7.22288 8.25678 6.88117Z"
    />
  </SvgIcon>
);

export default CaretDoublePrevIcon;
